import { createFileRoute } from '@tanstack/react-router';
import { PreferencesTab } from '@/features/account-settings/tabs/preferences';

export const Route = createFileRoute('/_authenticated/account-settings/preferences')({
    head: () => ({ meta: [{ title: 'Preferences | promote.fun' }] }),
    component: PreferencesTab,
});
